module.exports = __webpack_public_path__ + "media/images/icons/since-badge-white-en-8f3a73f18607f8df36a5a29d6ef791e9.svg";